import { RootState } from "../indexReducers";

// @ts-ignore
export const getSessionLoading_s = (state: RootState) =>
  state.sessionReducer.loading;
export const getUserRole_s = (state: RootState) => state.sessionReducer.role;
export const getTokenData = (state: RootState) =>
  state.sessionReducer.tokenData;
export const getTokenExpiration = (state: RootState) =>
  state.sessionReducer.tokenData?.tokenExpiration;
export const getTenants = (state: RootState) => state.sessionReducer.tenants;
export const getCurrentTenant = (state: RootState) =>
  state.sessionReducer.tokenData?.currentTenant;
export const getUserTenant = (state: RootState) => state.sessionReducer.tenant;
export const getSessionRead = (state: RootState) =>
  state.sessionReducer.sessionRead;
export const getAllowedScopes = (state: RootState) =>
  state.sessionReducer.tokenData?.allowedScopes;
